import commonInfo from "./common"
import gameConfig from "@/common/config/games"
export default{
    common:commonInfo,
    game:gameConfig,
    init(){
        window.gameapi = {}
        window.gameapi.playReward = function(d,d1){
            // debugger
            //d(true);
        }
        window.gameapi.playInterstitial=function(){
            //debugger
        }
    }
}


// WEBPACK FOOTER //
// ./src/common/global.js